import { StyleSheet } from "react-native";



export const SplashStyle = StyleSheet.create({
    viewStyle:{
        flex: 1, justifyContent: 'center', alignItems: 'center'
    },
    imgStyle:{
        height: 100, width: 165
    }
})